export default {
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/mixins/contextualable.js
// module id = N9Tp
// module chunks = 0